module.exports = __webpack_public_path__ + "img/142.f0824bf8.jpg";